import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=3ce1d42a"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports